import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { SearchBarComponent } from '@libs/shared/ui/search-bar/search-bar/search-bar.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgLetDirective } from '@libs/shared/utils/directives/ng-let/ng-let.directive';
import { ElasticsearchMultiAnalyzerListComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-multi-analyzer-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ElasticsearchAnalyzeTokenInlineResultComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-analyze-token-inline-result.component';
import { ElasticsearchSingleAnalyzerComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-single-analyzer.component';
import { ElasticsearchMultiAnalyzerComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-multi-analyzer.component';

@Component({
  selector: 'app-elasticsearch-term-analyzer',
  standalone: true,
  imports: [
    MatButtonModule,
    SearchBarComponent,
    MatInputModule,
    MatSelectModule,
    NgLetDirective,
    ElasticsearchMultiAnalyzerListComponent,
    MatTabsModule,
    ElasticsearchAnalyzeTokenInlineResultComponent,
    ElasticsearchSingleAnalyzerComponent,
    ElasticsearchMultiAnalyzerComponent
],
  template: `
    <mat-tab-group animationDuration="0">
      <mat-tab label="All Analyzers">
        <app-elasticsearch-multiple-analyzer />
      </mat-tab>
      <mat-tab label="Selected Analyzer">
        <app-elasticsearch-single-analyzer />
      </mat-tab>
    </mat-tab-group>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElasticsearchTermAnalyzerComponent {}
